import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { ZCDTooltip } from '@zencity/common-ui';

const SentimentSegment = ({ foregroundStyle, width, label, percentage, count }) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames('engage-sentiment-analysis-foreground', foregroundStyle)}
      style={{ width: `${width}%` }}
    >
      <ZCDTooltip
        text={
          <div className={classNames('engage-sentiment-analysis-tooltip-table')}>
            <table>
              <tr>
                <td>
                  <strong>{t('sentimentAnalysis.tableHeader')}</strong>
                </td>
                <td />
              </tr>
              <tr>
                <td>{label}</td>
                <td>{`${percentage}%`}</td>
              </tr>
              <tr>
                <td>{t('sentimentAnalysis.count')}</td>
                <td>{count}</td>
              </tr>
            </table>
          </div>
        }
      >
        <div className={classNames('engage-sentiment-tooltip-element')} />
      </ZCDTooltip>
    </div>
  );
};

SentimentSegment.propTypes = {
  foregroundStyle: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
};

export default SentimentSegment;
